import {useTranslation} from "next-i18next";

export default function HomeMap(){
    const {t} = useTranslation();

    return (
        <div className="w-full relative">
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14269.066114003019!2d3.132429525219209!3d42.250214627876325!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x12ba61e82d360919%3A0x748441c3405626bf!2sLEON%20INMOBILIARIA!5e1!3m2!1sde!2sus!4v1758787739497!5m2!1sde!2sus" className="w-full h-[400px]" loading="lazy"></iframe>

            <div className="absolute right-[5%] 2xl-small:right-[10%] top-[60%] -translate-y-1/2 text-white text-shadow hidden xl:block">
                <h5 className="font-bold text-[14px]">{t("homeMap.heading")}</h5>
                <p className="text-[15px] leading-[1.2] mt-2">{t("consts.address.line3")}</p>
                <p className="text-[15px] leading-[1.2]">{t("consts.address.line4")}</p>
                <p className="text-[15px] leading-[1.2]">{t("consts.contact.website")}</p>
                <p className="text-[15px] leading-[1.2]">{t("consts.contact.email")}</p>

                <p className="text-[15px] mt-2">{t("homeMap.contactText")}</p>
                <p className="text-[30px] font-light">{t("consts.contact.tel")}</p>
            </div>
        </div>
    );
}